export const FETCH_SETTINGS_DATA_SUCCESS = "FETCH_SETTINGS_DATA_SUCCESS";
export const FETCH_SETTINGS_DATA_ERROR = "FETCH_SETTINGS_DATA_ERROR";

export const POST_SETTINGS_SUCCESS = "POST_SETTINGS_SUCCESS";
export const POST_SETTINGS_ERROR = "POST_SETTINGS_ERROR";
